import dayjs from 'dayjs';
import Link from 'next/link';

import { Blog } from '../blog.types';
import BlogHeading from '../blog-heading';

import { ContentHeadline, ContentPanel } from 'shared/styles/components';
import { BlogPostContent, BlogTitleMeta } from './blog-post.styles';

type BlogPostProps = {
  blog: Blog;
  children: React.ReactNode;
};

export default function BlogPost({ blog, children }: BlogPostProps) {
  return (
    <>
      <ContentPanel>
        <ContentHeadline>
          <Link className="crumb" href="/blog">
            Blog
          </Link>
          <h1>
            <BlogHeading blog={blog} />
          </h1>
          <BlogTitleMeta>
            <Link href={blog.authorLink} target="_blank">
              {blog.authorLabel}
            </Link>
            <span>{dayjs(blog.date).format('MMMM DD, YYYY')}</span>
          </BlogTitleMeta>
        </ContentHeadline>
      </ContentPanel>
      <ContentPanel>
        <BlogPostContent>{children}</BlogPostContent>
      </ContentPanel>
    </>
  );
}
